import { html } from 'lit';
import type { OneUxCardElement } from '../OneUxCardElement.js';
import { getLangCode } from '../../../utils/getLangCode.js';
import { strings } from '../language.js';
import { register as _registerElement } from "../../one-ux-button/register-element.js";
import { register as _registerElement2 } from "../../one-ux-icon/register-element.js";
import type { SlotTemplateResult } from '../types.js';
import { toSlotTemplateResult } from '../toSlotTemplateResult.js';
import { LayoutSlotFragment } from './LayoutSlotFragment.js';
_registerElement2("icon-8a815dce1565cbbda305601dbc0e5676");
_registerElement("button-05c2df6f9e5259aa6d539d26ecc1763f");
export function SlotItemsEndFragment(this: OneUxCardElement): SlotTemplateResult {
  const hasSlotItemsEnd = this._hasSlot('items-end');
  const hasSlotExpandableContent = this._hasSlot('expandable-content');
  const hasSlot = hasSlotItemsEnd || hasSlotExpandableContent;
  const lang = getLangCode(this);
  const {
    close,
    expand
  } = strings[lang];
  const template = html` <div ?hidden=${!hasSlot} class="items-end-parent place-at-end columns">
    ${LayoutSlotFragment.call(this, 'items-end')}
    ${hasSlotExpandableContent ? html`<button-05c2df6f9e5259aa6d539d26ecc1763f
          class="card-toggle-button"
          ?disabled=${this.busy}
          implicit
          weight="low"
          label=${`${this.open ? close : expand}: ${this.label}`}
          hide-tooltip
          @click=${() => this.open = !this.open}
        >
          <icon-8a815dce1565cbbda305601dbc0e5676 icon=${this.open ? 'toggle-up' : 'toggle-down'}></icon-8a815dce1565cbbda305601dbc0e5676>
        </button-05c2df6f9e5259aa6d539d26ecc1763f>` : null}
  </div>`;
  return toSlotTemplateResult(template, hasSlot);
}